import React from "react";
import { ReactSVG } from "react-svg";

const ListLoading = ({}) => {
  let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
  return (
    <div className="">
      <div className="flow-root ">
        <div className="overflow-x-auto ">
          <div className="inline-block min-w-full align-middle ">
            <div className="overflow-hidden border border-gray-50 rounded-[4px]">
              <table className="min-w-full divide-y divide-gray-100">
                <thead className="bg-gray-20">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 w-[35.91%] pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      <a href="#" className="inline-flex items-center group">
                        Patient Information
                      </a>
                    </th>
                    <th
                      scope="col"
                      className="px-3 w-[11.34%] py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      className="px-3 w-[11.70%] py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      <a href="#" className="inline-flex items-center group">
                        Date of Birth
                      </a>
                    </th>
                    <th
                      scope="col"
                      className="px-3 w-[13%] py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Mobile Number
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 w-[11.34%] text-left text-sm font-semibold text-gray-900"
                    >
                      Health Card
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 w-[11.48%] text-left text-sm font-semibold text-gray-900"
                    >
                      <a href="#" className="inline-flex items-center group">
                        Last Access
                      </a>
                    </th>
                    <th
                      scope="col"
                      className="relative w-[5.2%] py-3.5 pl-3 pr-4 sm:pr-6"
                    >
                      <span className="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50 ">
                  {arr.map((item, index) => (
                    <tr
                      key={index}
                      className="transition-colors duration-300 cursor-pointer hover:bg-blue-100 "
                    >
                      <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-6">
                        <div className="w-2/3 h-4 bg-gradient-to-r from-gray-100 to-transparent" />
                      </td>
                      <td className="px-3 py-4 text-sm text-gray-700 whitespace-nowrap">
                        {" "}
                        <div className="w-2/3 h-4 bg-gradient-to-r from-gray-100 to-transparent" />
                      </td>
                      <td className="px-3 py-4 text-sm text-gray-700 whitespace-nowrap">
                        {" "}
                        <div className="w-2/3 h-4 bg-gradient-to-r from-gray-100 to-transparent" />
                      </td>
                      <td className="px-3 py-4 text-sm text-gray-700 whitespace-nowrap">
                        {" "}
                        <div className="w-2/3 h-4 bg-gradient-to-r from-gray-100 to-transparent" />
                      </td>
                      <td className="px-3 py-4 text-sm text-gray-700 whitespace-nowrap">
                        {" "}
                        <div className="w-2/3 h-4 bg-gradient-to-r from-gray-100 to-transparent" />
                      </td>
                      <td className="px-3 py-4 text-sm text-gray-700 whitespace-nowrap">
                        {" "}
                        <div className="w-2/3 h-4 bg-gradient-to-r from-gray-100 to-transparent" />
                      </td>
                      <td className="relative py-4 pl-3 pr-4 text-sm font-medium text-right whitespace-nowrap sm:pr-6">
                        <a
                          href="#"
                          className="text-indigo-600 hover:text-indigo-900"
                        >
                          <ReactSVG
                            src="/icons/more-options.svg"
                            className="w-6"
                          />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListLoading;
